import React from 'react';
export const PermissionContext = React.createContext(null);
const Permission = ({children}) => {
//todo check nationalId and permission
    return (
        <PermissionContext.Provider value={""}>
            {children}
        </PermissionContext.Provider>
    );
};

export default Permission;
